define('Store.EntryPoint', [
    'Store.Collection'
], function StoreEntryPoint(
    StoreCollection
) {
    'use strict';

    return {
        mountToApp: function mountToApp(application) {
            StoreCollection.getInstance().reset(SC.ENVIRONMENT.published.stores || []);
        }
    };
});
